import { render, staticRenderFns } from "./ProgressPage.vue?vue&type=template&id=22dbd8f6"
import script from "./ProgressPage.vue?vue&type=script&lang=js"
export * from "./ProgressPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports